export const ChevronDownTwo = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--chevron-down';
  color = color || '#303E47';

  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M13.1756 6L8.48514 10.6667L3.79468 6"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChevronDownTwo;
